import { IconProps } from '../types';

function ContentWrapOutlineIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      className={className || 'h-5 w-5'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 4v16M4 16h8c2.21 0 4-1.79 4-4h0c0-2.21-1.79-4-4-4H4m4 4l-4 4 4 4"
      />
    </svg>
  );
}

export default ContentWrapOutlineIcon;
